<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="经营模式名称" name="name"></c-form-item>
                    <c-form-item type="checkbox" label="" name="state" :options="state" ></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_management_model_edit" color="sys" @click="add">新增经营模式</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        label="经营模式名称"
                        name="name"
						width="200"
                >
                </c-table-column>

                <c-table-column
                        label="经营模式描述"
                        name="remark"
						width="400"
                ></c-table-column>

                <c-table-column
                        label="是否启用"
						width="80"
                >
                    <template v-slot="{data}">
						<span v-if="data.state == 2" style="color:green">启用</span>
						<span v-else style="color:red">停用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        power="b_product_brand_sort"
						            width="200"
                        @sort="sortHandle"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_management_model_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_management_model_edit" v-if="data.state == 2" @click="startHandle('1', data)">停用</c-table-button>
                        <c-table-button power="b_management_model_edit" v-else-if="data.state == 1" @click="startHandle('2', data)">启用</c-table-button>
                        <c-table-button power="b_management_model_edit" @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑经营模式' : '新增经营模式'" width="600" @resolve="submit">
            <c-form ref="editForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="经营模式名称" name="name" required></c-form-item>
                <c-form-item type="textarea" label="经营模式描述" name="remark"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_management_model',

        data() {
            return {
                editState: false,
				state:[{
						name: '停用',
						value: 1
					},{
						name: '启用',
						value: 2
					}
				],
				dicType: 'management_model'
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
				data.dic_type = this.dicType;
                this.$refs.table.load({
                    url: '/dic/list',
                    data
                });
            },

            add() {
                this.editState = false;
                this.$refs.editForm.clear();
                this.$refs.editForm.set({brand_name:'',remark:''});
                this.$refs.editDialog.open();
            },

            edit(val) {
                this.editState = true;
                this.$refs.editForm.set(val);
                this.$refs.editDialog.open();
            },


            sortHandle(row, type, next) {
                let submitData ={};
                submitData.type = type;
                if(type=='top' || type=='bottom'){
                    submitData.id = row.data.id;
                }
                if(type=='up'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.prev().data.id;
                    submitData.type = "";
                }
                if(type=='down'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.next().data.id;
                    submitData.type = "";
                }
				        submitData.dic_type = this.dicType;
                this.request({
                    url: '/dic/sort',
                    data: submitData,
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

            startHandle(type, data) {
                this.$confirm({
                    text: `确定要${type == '1' ? '停用' : '启用'}该经营模式吗？`,
                    resolve: () => {
                        this.request({
                            url: '/dic/updateState',
                            data: {
                                state: type,
                                id: data.id,
								                dic_type: this.dicType
                            },
                            loading: true,
                            success: () => {
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
			
			deleteHandle(data) {
			    this.$confirm({
			        text: `确定要删除该经营模式吗？`,
			        resolve: () => {
			            this.request({
			                url: '/dic/delete',
			                data: {
			                    id: data.id,
								dic_type: this.dicType
			                },
			                loading: true,
			                success: () => {
								this.$message({
									icon: 'success',
								    text: '删除成功'
								});
			                    this.$refs.table.update();
			                }
			            });
			        }
			    });
			
			},

            submit(stop) {
                stop();
                this.$refs.editForm.submit({
                    url: this.editState ? '/dic/edit' : '/dic/add',
                    rule: {
                        name: '请填写经营模式名称'
                    },
					dataFormatter: data => {
						data.dic_type = this.dicType;
						return data;
					},
                    success: (data, res) => {
                        this.$message({
                            text: '保存成功'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    }
                });
            }
        }
    }
</script>